import axios from 'axios';
import { CreateWelfareFieldCollectionInput } from 'views/fish-check/features/welfare-scoring/types/create-welfare-field-collection-input.type';

// PUT
// /ewosapi/v1/fieldregistration/fieldcollection/{fieldCollectionId}/welfare/{registrationId}
export const putFieldCollectionWelfare = async (
  fieldCollectionId: number,
  registrationId: number,
  request: CreateWelfareFieldCollectionInput
): Promise<number> => {
  await axios.put<number>(`/ewosapi/v1/fieldregistration/fieldcollection/${fieldCollectionId}/welfare/${registrationId}`, request);
  return registrationId;
};
